import { MessageSquare } from "lucide-react";
import { Typography } from "@mui/material";

const EmptyChatState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full bg-gray-50 text-center px-6">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-100 mb-6">
        <MessageSquare size={28} className="text-blue-600" />
      </div>

      <Typography variant="h6" className="font-semibold text-gray-800 mb-2">
        Select a conversation
      </Typography>

      <Typography variant="body2" className="text-gray-500 max-w-sm">
        Choose a chat from the sidebar to start messaging.
      </Typography>
    </div>
  );
};

export default EmptyChatState;
